import { preloadColumnsQuery } from "@/entities/column/api/use-columns-query";
import { ContentType } from "@/shared/gql/graphql";

export const preloadWorkflowBoardsQueries = async (_companySlug: string) => {
  // Preload columns for all content types that have workflows
  preloadColumnsQuery({
    contentType: ContentType.Tender,
  });

  preloadColumnsQuery({
    contentType: ContentType.Organisation,
  });

  preloadColumnsQuery({
    contentType: ContentType.CaseLaw,
  });

  preloadColumnsQuery({
    contentType: ContentType.ProcurementCalendar,
  });
};
